import React from 'react';
import { string, bool, arrayOf, oneOfType } from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { Subtract } from '@one-thd/sui-icons';

const KeyProductFeatureName = (props) => {
  const { name, simple } = props;
  return (
    <>
      {simple ? (
        <>
          <Typography truncate variant="body-sm">{name}</Typography>
          <Subtract size="small" color="subtle" />
        </>
      ) : (
        <Typography variant="h4">{name}</Typography>
      )}
    </>
  );
};

KeyProductFeatureName.propTypes = {
  name: oneOfType([string, arrayOf(string)]),
  simple: bool
};

KeyProductFeatureName.defaultProps = {
  name: null,
  simple: false
};

export default KeyProductFeatureName;